import React from "react";

export default function CancelDeliveryModal({
  open,
  reasons,
  reason,
  onReasonChange,
  onConfirm,
  onClose,
  cancelling,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full space-y-4">
        <h3 className="text-lg font-bold text-gray-900">Cancel Delivery</h3>
        <p className="text-xs text-gray-500">
          Select a reason for cancelling this trip:
        </p>

        <div className="space-y-2">
          {reasons.map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => onReasonChange(r)}
              className={`w-full text-left p-3 rounded-xl border text-sm font-medium transition-colors ${
                reason === r
                  ? "border-red-500 bg-red-50 text-red-700 font-bold"
                  : "border-gray-200 text-gray-700 hover:bg-gray-50"
              }`}
            >
              {r}
            </button>
          ))}
        </div>

        <div className="flex gap-3 pt-2">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-200 text-gray-700 rounded-xl font-medium text-sm"
          >
            Go Back
          </button>
          <button
            onClick={onConfirm}
            disabled={!reason || cancelling}
            className="flex-1 py-3 bg-red-600 text-white rounded-xl font-bold text-sm disabled:opacity-50"
          >
            {cancelling ? "Cancelling..." : "Confirm Cancel"}
          </button>
        </div>
      </div>
    </div>
  );
}
